import { Types } from "../prop-controllers";
import { responsiveIconRadioGroupValueSchema } from "../data";
import {
  versionedPropDef,
  typeArg
} from "../versioned";
const discriminator = {
  version: 1,
  dataKey: "prop-controllers::responsive-icon-radio-group::v1"
};
const ResponsiveIconRadioGroup = versionedPropDef(
  Types.ResponsiveIconRadioGroup,
  responsiveIconRadioGroupValueSchema,
  discriminator,
  typeArg(),
  typeArg()
);
export {
  ResponsiveIconRadioGroup
};
//# sourceMappingURL=responsive-icon-radio-group.js.map